import { render, staticRenderFns } from "./CarouselPanel.vue?vue&type=template&id=1bd4246a&scoped=true&"
import script from "./CarouselPanel.vue?vue&type=script&lang=js&"
export * from "./CarouselPanel.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPanel.vue?vue&type=style&index=0&id=1bd4246a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4246a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd4246a')) {
      api.createRecord('1bd4246a', component.options)
    } else {
      api.reload('1bd4246a', component.options)
    }
    module.hot.accept("./CarouselPanel.vue?vue&type=template&id=1bd4246a&scoped=true&", function () {
      api.rerender('1bd4246a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/CarouselPanel.vue"
export default component.exports